<template>
    <div class="modal-overflow">
      <p><i class="nc-icon nc-alert-circle-i" style="margin-right: 5px" /><span v-html="data.message"></span></p>
      <div class="col-md-12 text-center">
        <button @click="() => $emit('close')" class="btn btn-fill btn-info btn-wd pull-right">OK</button>
      </div>
    </div>
</template>

<script>
  export default {
    props: ['data']
  }
</script>
